import "../styles/TemplateDivisionElement.css";
import {
    faCaretDown,
    faCaretRight
} from "@fortawesome/free-solid-svg-icons";
import {useContext, useEffect, useState} from "react";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {findDivision, findDivisionType} from "../pages/MapTemplateEditor";
import {MapContext, SelectedContext} from "../pages/MapEditor";
import DivisionTypeElement from "./DivisionTypeElement";

const InlineIconButton = ({ icon, onClick, style }) => {
    return <div style={style} className="InlineIconButton" onClick={onClick}><FontAwesomeIcon icon={icon}/></div>;
}
const DivisionElement = ({ id, parentOpen = true, hoist = 0 }) => {
    const [ open, setOpen ] = useState(false);

    const { map, setMap, template } = useContext(MapContext);

    const { selectedLegendItem, setSelectedLegendItem } = useContext(SelectedContext);

    if (parentOpen === false && open) setOpen(false);

    const [ divisionData, setDivisionData ] = useState(null);
    const [ divisionType, setDivisionType ] = useState(null);

    useEffect(() => {
        const data = findDivision(id, template);
        const tipe = findDivisionType(data?.result.type, template);

        setDivisionType(tipe);
        setDivisionData(data);
    }, [id, template]);

    if (!divisionData) return;

    return (
        <>
            <div className="TemplateDivisionElement">
                <div className='self'
                     tabIndex={0} style={{ paddingLeft: ((1 + divisionData.depth - hoist) * 20) + 'px' }} onContextMenu={e => e.preventDefault()}>
                    <InlineIconButton icon={ open ? faCaretDown : faCaretRight } onClick={() => setOpen(!open)}
                                      style={{ opacity: divisionData.result.division_types?.length || divisionData.result.divisions?.length ? '100%' : 0 }}/>
                    <span className="name">{divisionData.result.name}</span>
                    <span className="type">:{divisionType.result.name}</span>
                </div>
                <div className="children" style={{ display: open ? "block" : "none" }}>
                    {divisionData.result.division_types?.map(divisionType => <DivisionTypeElement hoist={hoist} key={divisionType.id} parentOpen={open} id={divisionType.id}/>)}
                    {divisionData.result.divisions?.map(division => <DivisionElement hoist={hoist} key={division.id} parentOpen={open} id={division.id}/>)}
                </div>
            </div>
        </>
    );
}

export default DivisionElement;
